<script setup lang="ts">
import Pdf from "@/components/Pdf.vue"

const props = defineProps<{
    element: any
}>()
</script>

<template>
    <div class="ce-pdf">
        <pdf :file="'/media/' + props.element.fileName" :paginated="true"></pdf>
    </div>
</template>
